import React from 'react'

import service from "../../assets/images/resource/gworkforce.png";

const sBullet = {
    listStyle: 'circle',
    marginLeft: '20px'
}
const sPadBtm0 = {
    paddingBottom: '0'
}

const ProductFour = () => {
    return (
        <section>
            <figure>
                <img src={service} alt="" />
            </figure>
            <h2 style={sPadBtm0}><span>G-WORKFORCE</span></h2>
            <h3>Global Competency and Operator Performance System</h3>

            <p>
            Provides a comprehensive overview and deep insights into operator performance, risk and behavior while driving. This dynamic dashboard is designed to empower stakeholders with actionable intelligence derived from real-time data, so they can monitor, analyze and optimize operator behavior to improve efficiency, safety and productivity.
            </p>
            
            <p>&nbsp;</p>
            <h4>Benefit</h4>
            <ul>
                <li style={sBullet}>Operator competency and Gap Analysis to get fit learning process</li>
                <li style={sBullet}>Identify Operation Safety, Productivity and Maintenance for Operation Excelences</li>
                <li style={sBullet}>Data history inline of Operator behavior Analysis</li>
                <li style={sBullet}>Learning Management for Operator Training</li>
                <li style={sBullet}>Integrated with Simulator data*</li>
            </ul>
        </section>
    )
}

export default ProductFour